import { render } from "./ManualGuid.vue?vue&type=template&id=542ea6fc"
import script from "./ManualGuid.vue?vue&type=script&lang=js"
export * from "./ManualGuid.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/html/miw-alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__